import { Card, CardBody, Col } from "reactstrap";
import { BorderLeftText1, BorderLefts } from "../../../../Constant";
import { BORDER_LEFT } from "../../../../Data/Bonus Ui/CreativeCard";
import CommonCreativeCardHeader from "../Common/CommonCreativeCardHeader";
import { P } from "../../../../AbstractElements";

const BorderLeft = () => {
  return (
    <Col sm="12" md="6">
      <Card>
        <CommonCreativeCardHeader headerClass="border-l-primary border-3" title={BorderLefts} span={BORDER_LEFT} />
        <CardBody>
          <P>{BorderLeftText1}<br /><strong>Visit Us: </strong> 2600 Hollywood Blvd,Florida, United States- 33020<br /><strong>Mail Us:</strong>contact@us@gmail.com<br /><strong>Contact Number: </strong>(954) 357-7760
          </P>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BorderLeft;
